<div class="row row--primary">
  <bezugsrecht-back-link (back)="back()" label="bezugsrecht-page.bezugsrecht-buy.link-back" />
  @if (model?.announcement) {
    <div class="tile">
      <div class="col-12 mt-2 opacity-container" [class.active]="model.announcement">
        <div class="row mb-2">
          <div class="col-12">
            <h5
              [innerHTML]="
                'bezugsrecht-page.bezugsrecht-buy.title'
                  | transloco
                    : {
                        name: model.announcement.bzrBezeichnung,
                        isin: model.announcement.bzrIsin,
                      }
              "
            >
              &nbsp;
            </h5>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 mb-2">
            <div
              [innerHTML]="
                model.remainingSubscriptionRights > 0
                  ? ('bezugsrecht-page.bezugsrecht-buy.hint-remaining'
                    | transloco
                      : {
                          name: model.announcement.bzrBezeichnung,
                          isin: model.announcement.bzrIsin,
                          underlyingName: model.announcement.bezugAktieBezeichnung,
                          underlyingIsin: model.announcement.bezugAktieIsin,
                          remainingSubscriptionRights: model.remainingSubscriptionRights | number: '1.0-5',
                        })
                  : ('bezugsrecht-page.bezugsrecht-buy.hint'
                    | transloco
                      : {
                          name: model.announcement.bzrBezeichnung,
                          isin: model.announcement.bzrIsin,
                          underlyingName: model.announcement.bezugAktieBezeichnung,
                          underlyingIsin: model.announcement.bezugAktieIsin,
                        })
              "
            ></div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 mb-3 d-flex justify-content-center">
            <web-design-system-button [disabled]="!model.buyableAmount" (click)="loadPreview()">
              {{ 'bezugsrecht-page.bezugsrecht-buy.link-submit' | transloco | uppercase }}
            </web-design-system-button>
          </div>
          <div class="col-12 text-center">
            <a
              [routerLink]="rootUrl + '/' + BEZUGSRECHT_ROUTES.BUY_CUSTOM"
              class="link-secondary text-default"
              [innerHTML]="'bezugsrecht-page.bezugsrecht-buy.link-custom' | transloco"
              [attr.aria-label]="'bezugsrecht-page.bezugsrecht-buy.link-custom' | transloco"
            >
            </a>
          </div>
        </div>
      </div>
    </div>
  }
</div>
